import clsx from 'clsx';
import type * as React from 'react';

import type { GitSyncOperation, GitSyncProvider } from '@gitbook/app-database';
import { Icon } from '@gitbook/spine-icons';

/**
 * The GitSyncLogoStatus component displays the logo of the Git provider and a dot
 * indicator that shows the current state of the synchronization (running, success, failure)
 */
export function GitSyncLogoStatus(props: {
    provider: GitSyncProvider['type'];
    state: GitSyncOperation['state'];
}): React.ReactElement {
    const { state, provider } = props;

    const IconCo = provider === 'gitlab' ? Icon.GitLab : Icon.GitHub;

    return (
        <div className="relative flex">
            <IconCo size={20} />
            <DotIndicator state={state} />
        </div>
    );
}

/**
 * The DotIndicator component displays a dot with a background color that
 * depends on the current state of the operation
 */
function DotIndicator(props: { state: GitSyncOperation['state'] }): React.ReactElement {
    const { state } = props;

    const indicatorColors: Record<GitSyncOperation['state'], string> = {
        failure: 'bg-danger',
        success: 'bg-success',
        running: 'bg-primary',
    };

    return (
        <div
            className="absolute flex items-center justify-center rounded-full bg-base"
            style={{
                width: 9,
                height: 9,
                left: 15,
            }}
        >
            <div className={clsx('flex size-1.5 rounded-full', indicatorColors[state])} />
        </div>
    );
}
